// babyworld-backoffice\src\pages\delegates\EditDelegatesPage\index.js

import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Form, Button, Card, Space } from "antd";
import FormFields from "./FormFields";
import { getDelegateById, updateDelegate } from "../../../redux/slices/delegates/delegatesThunk";
import { toast } from "react-toastify";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 12 },
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

const EditDelegatesPage = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { id } = useParams();
  const history = useHistory();

  useEffect(() => {
    dispatch(getDelegateById(id));
  }, [dispatch, id]);

  const delegateByIdData = useSelector((state) => state.delegates.oneDelegateById?.data);

  // --- CHARGEMENT DES VALEURS INITIALES DANS LE FORMULAIRE ---
  useEffect(() => {
    if (delegateByIdData) {
      form.setFieldsValue({
        firstName: delegateByIdData.firstname,
        lastName: delegateByIdData.lastname,
        email: delegateByIdData.user?.email || "",
        phone: delegateByIdData.phoneNumber,
        address: delegateByIdData.address || "", 
        latitude: delegateByIdData.latitude || "",   
        longitude: delegateByIdData.longitude || "", 
        category: delegateByIdData.category || undefined, 
        excludeFromStats: delegateByIdData.excludeFromStats,
      });
    }
  }, [delegateByIdData, form]);

  // Nettoyage automatique des coordonnées si un zoom ou une virgule parasite est collé
  const cleanCoord = (val) => {
    if (!val) return null;
    let s = String(val).trim();
    if (s.includes('.') && s.includes(',')) s = s.split(',')[0]; // Coupe le zoom ',15'
    else if (s.includes(',')) s = s.replace(',', '.');
    return s.replace(/[^\d.-]/g, '') || null;
  };

  // --- ENREGISTREMENT ---
  const onFinish = (values) => {
    const formattedValues = {
      firstname: values.firstName,
      lastname: values.lastName,
      email: values.email,
      phoneNumber: values.phone,
      address: values.address, 
      latitude: cleanCoord(values.latitude),   // <-- Nettoie automatiquement
      longitude: cleanCoord(values.longitude), // <-- Nettoie automatiquement
      category: values.category || null, 
      excludeFromStats: values.excludeFromStats,
      photo: null,
    };

    dispatch(updateDelegate({
        userId: id,
        userData: formattedValues,
    })).then((res) => {
        if (res.meta.requestStatus === "fulfilled") {
            toast.success("Délégué mis à jour avec succès.");
            history.push("/délégués");
        } else {
            toast.error("Erreur lors de la mise à jour.");
        }
    });
  };

  const onReset = () => {
    form.resetFields();
  };

  const navigateTo = (path) => {
    history.push(path);
  };

  return (
    <div>
      <Card
        bordered={false}
        className="criclebox tablespace mb-24"
        title="Modifier un délégué"
      />
      <Card bordered={false}>
        <Form {...layout} form={form} name="control-hooks" onFinish={onFinish}>
          <FormFields form={form} />
          <Form.Item {...tailLayout}>
            <Space size="small">
              <Button type="primary" htmlType="submit">
                Enregistrer
              </Button>
              <Button htmlType="button" onClick={onReset}>
                Reset
              </Button>
              <Button
                type="link"
                htmlType="button"
                onClick={() => navigateTo("/délégués")}
              >
                Annuler
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default EditDelegatesPage;